<template>
    <v-data-table
        class="pending-tasks"
        :headers="headers"
        :items="tasksComp.filteredPendingTasks"
        item-key="key"
        disable-pagination
        hide-default-footer
        :loading="tasksComp.loading"
        sort-by="daysRemaining"
        :sort-desc="false"
        :search="search"
        no-data-text="Няма обекти за обслужване"
    >
        <template v-slot:top>
            <VFilter :tasksComp="tasksComp" :search.sync="search" :distance="true"></VFilter>
        </template>

        <template v-slot:body="{ items, headers }">

                <tbody v-for="item in items" :key="item.key">
                    <tr v-for="(mat, i) in item.mats" :key="mat.id">
                        <template v-for="header in headers">
                            <td
                                v-if="i == 0 || header.matprop"
                                :key="header.value"
                                :rowspan="header.matprop ? '' : item.mats.length"
                                :class="{'mat-cell': header.matprop}"
                            >
                                <template v-if="header.value == 'actions'">
                                    <v-row justify="end">
                                        <v-edit-dialog v-if="item.combinations.length">
                                            <template v-slot:input>
                                                <v-simple-table>
                                                    <thead>
                                                        <tr>
                                                            <th>Пренасрочване</th>
                                                            <th>Комбиниране с обект</th>
                                                            <th>Разстояние</th>
                                                            <th>Действия</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="d in item.combinations" :key="d.target.id">
                                                            <td>
                                                                {{ item.formattedDate }} → {{ d.target.formattedDate }}
                                                            </td>
                                                            <td>{{ `${d.target.location.client.name}, ${d.target.location.address}, ${d.target.location.city}` }}</td>
                                                            <td>{{ d.distance.human_readable().toString() }}</td>
                                                            <td>
                                                                <v-btn small icon
                                                                    @click="tasksComp.dispatch(item.id, d.mats, d.target.service_date)"
                                                                    title="Комбинирай">
                                                                    <v-icon>mdi-check-bold</v-icon></v-btn>
                                                                <v-btn small icon
                                                                    @click="tasksComp.combinationMarkers = [item, d.target], tasksComp.flyTo(item.latLng, d.target.latLng)"
                                                                    title="Покажи обектите на картата">
                                                                    <v-icon>mdi-map-marker-multiple</v-icon></v-btn>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </template>
                                            <v-badge color="accent" :content="item.combinations.length" overlap>
                                                <v-btn color="primary" small icon><v-icon>mdi-link-variant</v-icon></v-btn>
                                            </v-badge>
                                        </v-edit-dialog>
                                        <v-btn color="primary" small icon
                                            @click="tasksComp.dispatch(item.id, item.mats, item.serviceDate)"
                                            title="Потвърди"><v-icon>mdi-check-bold</v-icon></v-btn>
                                        <v-btn color="primary" small icon
                                            @click="tasksComp.flyTo(item.latLng)"
                                            title="Покажи на картата"><v-icon>mdi-map-marker</v-icon></v-btn>
                                    </v-row>
                                </template>

                                <template v-else-if="header.value == 'serviceDate'">
                                    <span :class="{'red--text': item.daysRemaining < 0,
                                                    'orange--text': item.daysRemaining == 0,
                                                    'blue--text': item.daysRemaining == 1}">{{ item.formattedDate }}</span>
                                </template>

                                <template v-else-if="header.value == 'department_id'">
                                    {{ tasksComp.departmentsById[item.department_id] }}
                                </template>

                                <template v-else-if="header.value == 'payment'">
                                    {{ paymentMethods[mat.payment_method] }} / {{paymentDocuments[mat.payment_document] }}
                                </template>

                                <template v-else-if="header.matprop">
                                    {{ path(header.value.split('.'), {mat}) }}
                                </template>

                                <template v-else>
                                    {{ path(header.value.split('.'), item) }}
                                </template>


                            </td>
                        </template>
                    </tr>
                </tbody>
        </template>

    </v-data-table>
</template>

<style scoped>

.pending-tasks table td:not(:last-child),
.pending-tasks table td.mat-cell {
    border-right: solid 1px rgb(0, 0, 0, 0.12) !important;
}

.pending-tasks table td {
    border-bottom: solid 1px rgb(0, 0, 0, 0.12) !important;
}

.pending-tasks tbody:hover {
    background-color: #eee;
}
</style>


<script>
import VFilter from './Filter'
import { paymentMethods, paymentDocuments } from '../LocationEditor'
import * as util from '../../util'
import { path } from 'ramda'

export default {
    props: [ 'tasksComp' ],
    data() {
        return {
            search: '',
            paymentMethods: util.itemsToByValue(paymentMethods),
            paymentDocuments: util.itemsToByValue(paymentDocuments),
        }
    },
    computed: {
        headers() {
            return [
                ...(this.$root.department === null ?
                    [ { value: 'department_id', text: 'Отдел', filterable: false } ]
                    : []
                ),
                ...[
                    { value: 'client.name', text: 'Клиент' },
                    { value: 'fullAddress', text: 'Адрес' },
                    { value: 'comment', text: 'Забележка за обекта', sortable: false},
                    { value: 'serviceDate', text: 'Дата', filterable: false},
                    { value: 'mat.type.code', text: 'Код', filterable: false, sortable: false, matprop: true},
                    { value: 'mat.type.full', text: 'Вид', filterable: false, sortable: false, matprop: true},
                    { value: 'mat.count', text: 'Брой', filterable: false, sortable: false, matprop: true},
                    { value: 'mat.color', text: 'Цвят', filterable: false, sortable: false, matprop: true},
                    { value: 'mat.payment', text: 'Плащане', filterable: false, sortable: false, matprop: true},
                    { value: 'mat.comment', text: 'Забележка', filterable: false, sortable: false, matprop: true},
                    { value: 'actions', text: 'Действия', align: 'right', sortable: false, filterable: false }
                ]
            ];
        }
    },
    methods: {
        formatDayOffset(doff) {
            const adoff = Math.abs(doff);
            return `${adoff} ${adoff == 1 ? 'ден' : 'дни'} ${doff < 0 ? 'по-рано' : 'по-късно'}`;
        },
        path
    },
    components: {
        VFilter
    }
}
</script>